import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  TIndirectTaxCustomerExemptionResponse,
  TIndirectTaxCustomerExemptionsHookParams,
} from './types';

export function useIndirectTaxCustomerExemptions({
  cursor = null,
  limit = 10,
  filters,
}: TIndirectTaxCustomerExemptionsHookParams) {
  const query = new URLSearchParams();

  query.append('limit', limit.toString());

  if (filters.corporationId) {
    query.append('corporation_id', filters.corporationId.toString());
  }

  if (cursor) {
    query.append('cursor', cursor);
  }

  if (filters.certificateTypes) {
    query.append('certificate_types', filters.certificateTypes.join(','));
  }

  if (filters.exemptionJurisdiction) {
    query.append(
      'exemption_jurisdiction',
      filters.exemptionJurisdiction.join(',')
    );
  }

  if (filters.exemptionStatus) {
    query.append('exemption_status', filters.exemptionStatus);
  }

  if (filters.expirationStatus) {
    query.append('expiration_status', filters.expirationStatus);
  }

  const { data, mutate, error, isLoading } =
    useSWR<TIndirectTaxCustomerExemptionResponse>(
      filters.customerId
        ? `new-sales-tax/customers/${filters.customerId}/exemptions?${query}`
        : null,
      SWRFetcher({ method: 'GET' }, undefined)
    );

  return {
    exemptions: data?.data.exemptions,
    cursor: data?.data.cursor,
    totalExemptions: data?.data.total_exemptions,
    isLoading,
    mutate,
    error,
  };
}
